import { CheckBox, LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import React, { useEffect, useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { ImageItemCont, ImageElement } from './ImageBin.styles';
import noImg from './no-image.png';

interface Props {
  item: IMedia;
  checked: boolean;
  handleSelect: (media: IMedia) => void;
  zoom: boolean;
  imageOrientation?: 'landscape' | 'portrait';
}

const ImageBinItem: React.FC<Props> = ({ item, checked, handleSelect, zoom, imageOrientation }) => {
  const [source, setsource] = useState<string>(
    item.attributes.modified_attachment_url || item.attributes.attachment_url,
  );
  const [loaded, setloaded] = useState(false);
  const [disabled, setdisabled] = useState(false);

  useEffect(() => {
    const i: HTMLImageElement = new Image();

    i.onload = function () {
      setloaded(true);
      if (imageOrientation) {
        if (i.height < i.width) {
          //Landscape image
          setdisabled(imageOrientation === 'portrait');
        } else {
          //portrait
          setdisabled(imageOrientation === 'landscape');
        }
      }
    };

    i.src = item.attributes.attachment_url;
  }, [item.attributes.attachment_url]);

  return (
    <ImageItemCont
      onClick={() => handleSelect(item)}
      zoom={zoom}
      style={{ opacity: disabled ? 0.3 : 1, pointerEvents: disabled ? 'none' : 'all' }}
    >
      {!loaded ? (
        <LoadingSpinnerIconTwoTone style={{ width: 40, height: 40 }} />
      ) : (
        <>
          <div style={{ position: 'absolute', top: -5, left: -5 }}>
            <CheckBox
              disabled={disabled}
              checked={checked}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(item);
              }}
            />
          </div>

          <ImageElement
            zoom={zoom}
            // style={{ width: img.attributes.file_width || img.attributes.medium_width }}
            draggable={false}
            src={`${source}/0x250`}
            onError={() => setsource(noImg)}
            onLoad={() => setloaded(true)}
          />
        </>
      )}
    </ImageItemCont>
  );
};

export default ImageBinItem;
